"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const CalculatorMenu = () => {
    const pathname = usePathname();

    const menuItems = [
        {
            label: "Overview",
            href: "/calculators-home-tools",
        },
        {
            label: "Refinance",
            href: "/refinance-calculator",
        },
        {
            label: "Payment",
            href: "/payment-calculator",
        },
    ];

    return (
        <div className="w-full mt-20 bg-transparent z-50">
            <div className="w-full mb-10">
                <div className="max-w-[1100px] mx-auto px-4">
                    <ul className="flex space-x-4 list-none gap-4">
                        {menuItems.map((item) => {
                            const isActive = pathname === item.href;

                            return (
                                <li key={item.href}>
                                    <Link
                                        href={item.href}
                                        aria-current={isActive ? "page" : undefined}
                                        className={`font-bold text-[15px]  border-b-4 pb-3 transition-all duration-200 ${
                                            isActive
                                                ? "text-blue border-blue"
                                                : "text-gray-700 border-transparent hover:text-[#1275b9] hover:border-[#1275b9]"
                                        }`}
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CalculatorMenu;
